import { render, staticRenderFns } from "./huoyue.vue?vue&type=template&id=749d6912&scoped=true"
import script from "./huoyue.vue?vue&type=script&lang=js"
export * from "./huoyue.vue?vue&type=script&lang=js"
import style0 from "./huoyue.vue?vue&type=style&index=0&id=749d6912&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749d6912",
  null
  
)

export default component.exports